import {CommonModule} from "@angular/common";
import {HttpClientModule} from '@angular/common/http';
import {CatalogService} from "./_services/catalog.service";
import {ModuleWithProviders, NgModule} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PriceService} from "../price/price.service";
import {QuotesService} from "../quotes/quotes.service";
import {AuthGuard} from "./_guards/auth.guard";
import {GoogleAnalyticsGuard} from "./_guards/ga.guard";
import {LandingPageGuard} from './_guards/landing-page.guard';
import {QuotesGuard} from "./_guards/quotes.guard";
import {AuthService} from "./_services/auth.service";
import {BookService} from "./_services/book.service";
import {GeocodeService} from "./_services/geocode.service";
import {JobService} from "./_services/job.service";
import {MembershipService} from "./_services/membership.service";
import {NewuserService} from "./_services/newuser.service";
import {PrintService} from "./_services/print.service";
import {UrlParamsService} from './_services/url-params.service';
import {UserService} from "./_services/user.service";
import {UtilitiesService} from "./_services/utilities.service";
import {BannerComponent} from './banner/banner.component';
import {LowerCaseUrlSerializer} from './lowerCaseUrlSerializer';
import { RoleService } from "./_services/role.service";
import {SharedModule} from "../shared/shared.module";
import { CurrencyService } from "./_services/currency.service";
import {WrenchBottomSheetService} from "../wrench-bottom-sheet/wrench-bottom-sheet.service";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        FontAwesomeModule,
        SharedModule
    ],
    declarations: [
        BannerComponent
    ],
    exports: [
        RouterModule,
        CommonModule,
        BannerComponent
    ],
    providers: [
        WrenchBottomSheetService
    ]
})

export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                Title,
                UtilitiesService,
                PrintService,
                GoogleAnalyticsGuard,
                LandingPageGuard,
                QuotesGuard,
                AuthGuard,
                AuthService,
                CatalogService,
                JobService,
                UserService,
                RoleService,
                NewuserService,
                GeocodeService,
                MembershipService,
                UrlParamsService,
                PriceService,
                BookService,
                QuotesService,
                LowerCaseUrlSerializer,
                CurrencyService,
            ],
        };
    }
}
